import type { FireIconProps } from './types';

export default function SprinklerHead({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Ceiling line */}
      <line x1="2" y1="3" x2="22" y2="3" />
      {/* Pipe */}
      <line x1="12" y1="3" x2="12" y2="7" />
      {/* Sprinkler body */}
      <rect x="10" y="7" width="4" height="3" rx="0.5" />
      {/* Deflector plate */}
      <path d="M7 12h10" />
      <path d="M8 10l-1 2" />
      <path d="M16 10l1 2" />
      {/* Water spray */}
      <line x1="8" y1="14" x2="6" y2="18" />
      <line x1="10" y1="14" x2="9" y2="19" />
      <line x1="12" y1="13" x2="12" y2="20" />
      <line x1="14" y1="14" x2="15" y2="19" />
      <line x1="16" y1="14" x2="18" y2="18" />
    </svg>
  );
}
